import { publish, subscribe } from '~/event-bus';
import { localiseUrl, parseHTML } from '~/helpers';
import { HTMLCustomElement } from '~/theme';

customElements.define(
  'quick-buy-button',
  class QuickBuyButton extends HTMLCustomElement {
    connectedCallback() {
      this.targets.button.addEventListener('click', (event) => {
        event.preventDefault();

        publish('quick-buy-product', {
          handle: this.getAttribute('product-handle'),
        });
      });
    }
  }
);

customElements.define(
  'quick-buy-modal',
  class QuickBuyModal extends HTMLCustomElement {
    connectedCallback() {
      subscribe('quick-buy-product', (payload) => {
        if (payload.handle === this.handle) {
          publish('toggle-element', 'quick-buy');
          return;
        }

        fetch(`/products/${payload.handle}`)
          .then((response) => response.text())
          .then((response) => {
            this.targets.content.innerHTML = parseHTML(response, 'main-product').outerHTML;
            this.handle = payload.handle;
            this.targets.content.scrollTop = 0;

            publish('toggle-element', 'quick-buy');
          });
      });
    }
  }
);
